import type { NavItem } from '@billy/design-system'
import type { TFunction } from 'i18next'

import { ProductType } from '@features/products/enums/productType'

export const getProductTypeItems = (t: TFunction): NavItem<ProductType>[] => [
  {
    children: t('external_invoices.product_type_toggle_group.label.goods'),
    id: ProductType.Goods,
    value: ProductType.Goods,
  },
  {
    children: t('external_invoices.product_type_toggle_group.label.services'),
    id: ProductType.Services,
    value: ProductType.Services,
  },
]
